import React, { useState, useEffect, useCallback, use, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DevisList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaCashRegister, FaCheckCircle, FaEdit, FaEllipsisH, FaFilePdf, FaFilter, FaInfo, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import DevisForm from './DevisForm';
import { devisActions } from '../../sagas/devisSlice';
import { useNavigate } from 'react-router-dom';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { productActions } from '../../sagas/productSlice';
import { debounce } from 'lodash';
import { clientActions } from '../../sagas/clientSlice';
import Select from "react-select";

const DevisList = () => {
    const dispatch = useDispatch();
    const list = useSelector((state) => state.devis.list);
    const loading = useSelector((state) => state.devis.loading);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedDevis, setSelectedDevis] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const clients = useSelector(state => state.clients.clients);
    const [selectedClient, setSelectedClient] = useState(null);

    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const searchInputRef = useRef(null);

    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });


    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(devisActions.list(payload));
    }, [filters]);


    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    const handleGeneratePdf = (devis) => {
        Swal.fire({
            title: t('commande.pdfPriceOption', 'Prix à afficher'),
            text: t('commande.pdfPriceOptionText', 'Choisissez le type de prix à afficher dans le PDF'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('commande.prixTTC', 'Prix TTC'),
            cancelButtonText: t('commande.prixHT', 'Prix HT'),
            showCloseButton: true,
            closeButtonHtml: '&times;',
        }).then((result) => {
            // If user closes the dialog without choosing, don't generate PDF
            if (result.dismiss === Swal.DismissReason.close) {
                return;
            }

            // Determine if we should show TTC prices (confirmed) or HT prices (canceled)
            const showTTCPrices = result.isConfirmed;
            // Create a wrapper function for convertNumberToWords to add the currency suffix
            const convertAmountToWords = (amount) => {
                const words = convertNumberToWords(amount);
                return `${words} dirhams`;
            };

            // Create PDF with slightly larger page format for better layout
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            // Set document properties
            doc.setProperties({
                title: `Devis ${devis.numero}`,
                subject: 'Devis client',
                author: 'MatjarPOS',
                creator: 'MatjarPOS System'
            });

            // Get page dimensions
            const pageWidth = doc.internal.pageSize.width;
            const pageHeight = doc.internal.pageSize.height;
            const margin = 15;
            const footerHeight = 20;
            const headerHeight = 40;

            // Extract client information
            const clientName = devis.clientNom;
            const clientContact = [
                devis.clientTelephone1,
                devis.clientEmail,
            ].filter(Boolean).join(", ");

            // Use actual company data from the Redux store if available
            const companyData = {
                name: company?.name || "Ma Société",
                subtitle: company?.subtitle || "Votre partenaire de confiance",
                address: company?.address || "123 Rue Exemple, Ville",
                phone1: company?.phone1 || "0123456789",
                phone2: company?.phone2 || "0987654321",
                email: company?.email || "contact@masociete.com",
                cnss: company?.cnss || "123456789",
                ice: company?.ice || "123456789",
                rc: company?.rc || "123456789",
                if: company?.identificationFiscale || "123456789",
                logo: company?.logo || null,
                website: company?.website || "www.ideracloud.com",
            };

            // Function to add header to each page
            const addHeader = (doc, isFirstPage = false) => {
                // Add modern header with gradient
                doc.setFillColor(41, 128, 185); // Primary blue
                doc.rect(0, 0, pageWidth, isFirstPage ? headerHeight : 20, 'F');
                doc.setFillColor(52, 152, 219); // Secondary blue for gradient effect
                doc.rect(0, 0, pageWidth, 5, 'F');

                // Add logo if available and it's the first page
                if (isFirstPage && companyData.logo) {
                    try {
                        doc.addImage(companyData.logo, 'JPEG', margin, 10, 40, 20);
                    } catch (e) {
                        console.error("Error adding logo to PDF", e);
                    }
                }

                // Add company name and subtitle with improved styling
                doc.setTextColor(255, 255, 255);

                if (isFirstPage) {
                    doc.setFontSize(22);
                    doc.setFont('helvetica', 'bold');
                    doc.text(companyData.name, pageWidth / 2, 18, { align: 'center' });
                    doc.setFontSize(12);
                    doc.setFont('helvetica', 'normal');
                    // Split subtitle into multiple lines if needed
                    const subtitleMaxWidth = pageWidth - (margin * 2); // Use margins to determine max width
                    const wrappedSubtitle = doc.splitTextToSize(companyData.subtitle, subtitleMaxWidth);
                    doc.text(wrappedSubtitle, pageWidth / 2, 25, { align: 'center' });

                    // Add company contact info in header
                    doc.setFontSize(8);
                    doc.text(`${companyData.address} | Tél: ${companyData.phone1} | Email: ${companyData.email}`, pageWidth / 2, 35, { align: 'center' });
                } else {
                    // Simplified header for continuation pages
                    doc.setFontSize(12);
                    doc.setFont('helvetica', 'bold');
                    doc.text(`DEVIS N° ${devis.numero} (Suite)`, pageWidth / 2, 12, { align: 'center' });
                }
            };

            // Function to add footer to each page
            const addFooter = (doc) => {
                // Add footer with modern design
                doc.setFillColor(41, 128, 185);
                doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, 'F');

                doc.setFontSize(9);
                doc.setTextColor(255, 255, 255);
                doc.setFont('helvetica', 'normal');
                doc.text(companyData.name, pageWidth / 2, pageHeight - 14, { align: 'center' });
                doc.setFontSize(7);
                doc.text(`${companyData.address} | Tél: ${companyData.phone1} | Email: ${companyData.email} | ICE: ${companyData.ice}`, pageWidth / 2, pageHeight - 9, { align: 'center' });
                doc.text(`RC: ${companyData.rc} | IF: ${companyData.if} | CNSS: ${companyData.cnss} | ${companyData.website}`, pageWidth / 2, pageHeight - 4, { align: 'center' });

                // Add page number
                doc.setFontSize(8);
                doc.setTextColor(255, 255, 255);
                doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth / 2, pageHeight - 20, { align: 'center' });
            };

            // Add first page header
            addHeader(doc, true);

            // Add document title with elegant styling
            doc.setFillColor(240, 240, 240);
            doc.roundedRect(margin, 45, pageWidth - (2 * margin), 12, 2, 2, 'F');
            doc.setTextColor(41, 128, 185);
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text(`DEVIS N° ${devis.numero}`, pageWidth / 2, 53, { align: 'center' });

            // Format date with better styling
            const formattedDate = new Date(devis.dateCreation).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            // Add Information blocks with improved card-like styling - REDUCED HEIGHT
            // Client Information Card - Adjusted height to accommodate chantier info
            doc.setFillColor(248, 249, 250);
            doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'S');

            // Client Information Header
            doc.setFillColor(41, 128, 185);
            doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 8, 2, 2, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text("DESTINATAIRE", margin + ((pageWidth - (3 * margin)) / 4), 70.5, { align: 'center' });

            // Client Information Content - Reduced spacing
            doc.setTextColor(60, 60, 60);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text(clientName, margin + 5, 78);
            doc.setFont('helvetica', 'normal');
            doc.text(`Adresse: ${devis.clientAdresse || "N/A"}`, margin + 5, 83);
            doc.text(`Contact: ${clientContact}`, margin + 5, 90);
            doc.text(`ICE: ${devis.clientIce || "N/A"}`, margin + 5, 95);
            
            // Add chantier information if available
            if (devis.chantierNom) {
                doc.setFont('helvetica', 'bold');
                doc.text(`Chantier: ${devis.chantierNom}`, margin + 5, 100);
            }

            // Devis Information Card - Adjusted height to match client card
            const rightColumnX = margin * 2 + (pageWidth - (3 * margin)) / 2;
            doc.setFillColor(248, 249, 250);
            doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 40, 2, 2, 'S');

            // Devis Information Header
            doc.setFillColor(41, 128, 185);
            doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 8, 2, 2, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text("INFORMATION DEVIS", rightColumnX + ((pageWidth - (3 * margin)) / 4), 70.5, { align: 'center' });

            // Devis Information Content - Reduced spacing
            doc.setTextColor(60, 60, 60);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.text(`Numéro: ${devis.numero}`, rightColumnX + 5, 78);
            doc.text(`Date: ${formattedDate}`, rightColumnX + 5, 83);
            doc.text(`Validité: ${devis.validite || 30} jours`, rightColumnX + 5, 88);

            // Start table at a lower Y position to accommodate chantier info
            const tableStartY = 110;

            // Add table for items with improved styling - keeping remise in DH and rounding values
            const tableData = devis.lignes.map((ligne) => {
                if (showTTCPrices) {
                    // Show TTC prices
                    return [
                        ligne.articleCode,
                        ligne.articleNom,
                        ligne.quantite,
                        unites.find(u => u.code === ligne.unite)?.libelle,
                        `${(ligne.prixUnitaireTTC).toFixed(2)}`,
                        `${(ligne.montantTTC).toFixed(2)}`,
                    ];
                } else {
                    // Show HT prices
                    return [
                        ligne.articleCode,
                        ligne.articleNom,
                        ligne.quantite,
                        unites.find(u => u.code === ligne.unite)?.libelle,
                        `${(ligne.prixUnitaireTTC / (1 + ligne.tauxTVA)).toFixed(2)}`,
                        `${(ligne.montantHT).toFixed(2)}`,
                    ];
                }
            });

            // Add the table with automatic pagination - Optimized for space
            autoTable(doc, {
                startY: tableStartY,
                head: [["Code", "Description", "Qté", "UM", showTTCPrices ? "PU TTC" : "PU HT", showTTCPrices ? "Total TTC" : "Total HT"]],
                body: tableData,
                styles: {
                    fontSize: 9,
                    cellPadding: 3, // Reduced padding from 4 to 3
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    halign: 'center',
                },
                columnStyles: {
                    0: { halign: 'center', cellWidth: 25 },
                    1: { halign: 'center', cellWidth: 55 },
                    2: { halign: 'center', cellWidth: 20 },
                    3: { halign: 'center', cellWidth: 25 },
                    4: { halign: 'center', cellWidth: 25 },
                    5: { halign: 'center', cellWidth: 25 },
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245],
                },
                margin: { top: tableStartY, right: margin, bottom: 30, left: margin },
                didDrawPage: (data) => {
                    // Add header and footer on each page
                    if (data.pageNumber > 1) {
                        addHeader(doc, false);
                    }
                    addFooter(doc);
                },
            });

            // Get the Y position after the table
            let currentY = doc.lastAutoTable.finalY + 5; // Reduced spacing from 10 to 5

            // Calculate totals with rounding
            const totalHT = (devis.montantTotalTTC - devis.montantTotalTaxe).toFixed(2);
            const tva = (devis.montantTotalTaxe).toFixed(2);
            const totalTTC = (devis.montantTotalTTC).toFixed(2);

            // For small devis (3 lines or less), we need to optimize space usage
            // Calculate space needed more accurately based on number of lines
            const isSmallDevis = devis.lignes.length <= 10;

            // Reduced space requirements for small devis
            const spaceNeeded = isSmallDevis ? 60 : 120;

            // Only add a new page if absolutely necessary
            if (currentY + spaceNeeded > pageHeight - footerHeight - 10) {
                doc.addPage();
                addHeader(doc, false);
                addFooter(doc);
                currentY = 30; // Reset Y position on new page
            }

            // Create a modern summary box - Reduced height for small devis
            const summaryHeight = isSmallDevis ? 34 : 38;
            doc.setFillColor(248, 249, 250);
            doc.roundedRect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, summaryHeight, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, summaryHeight, 2, 2, 'S');

            // Add summary lines - Optimized spacing for small devis
            doc.setFontSize(9);
            doc.setTextColor(60, 60, 60);
            doc.setFont('helvetica', 'normal');

            // Summary rows with alternating background - Reduced heights
            const rowHeight = isSmallDevis ? 10 : 12;
            doc.setFillColor(240, 240, 240);
            doc.rect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, rowHeight, 'F');
            doc.text("Total HT:", rightColumnX + 5, currentY + (rowHeight * 0.7));
            doc.setFont('helvetica', 'bold');
            doc.text(`${totalHT} DH`, rightColumnX + (pageWidth - (3 * margin)) / 2 - 5, currentY + (rowHeight * 0.7), { align: 'right' });

            doc.setFont('helvetica', 'normal');
            doc.text("Total TVA (20%):", rightColumnX + 5, currentY + rowHeight + (rowHeight * 0.7));
            doc.setFont('helvetica', 'bold');
            doc.text(`${tva} DH`, rightColumnX + (pageWidth - (3 * margin)) / 2 - 5, currentY + rowHeight + (rowHeight * 0.7), { align: 'right' });

            // Total row with highlight - Reduced height for small devis
            const totalRowHeight = isSmallDevis ? 12 : 14;
            doc.setFillColor(41, 128, 185);
            doc.rect(rightColumnX, currentY + (rowHeight * 2), (pageWidth - (3 * margin)) / 2, totalRowHeight, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFont('helvetica', 'bold');
            doc.text("TOTAL TTC:", rightColumnX + 5, currentY + (rowHeight * 2) + (totalRowHeight * 0.7));
            doc.text(`${totalTTC} DH`, rightColumnX + (pageWidth - (3 * margin)) / 2 - 5, currentY + (rowHeight * 2) + (totalRowHeight * 0.7), { align: 'right' });

            // Add amount in words with better styling - Reduced height for small devis
            const amountForWords = showTTCPrices ? totalTTC : totalHT;
            const totalInWords = convertAmountToWords(amountForWords);
            const wordsBoxHeight = isSmallDevis ? 25 : 30;
            doc.setFillColor(245, 245, 245);
            doc.roundedRect(margin, currentY, (pageWidth - (3 * margin)) / 2, wordsBoxHeight, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(margin, currentY, (pageWidth - (3 * margin)) / 2, wordsBoxHeight, 2, 2, 'S');

            doc.setTextColor(41, 128, 185);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text("Arrêté le présent devis à la somme de:", margin + 5, currentY + 8);
            doc.setTextColor(60, 60, 60);
            doc.setFont('helvetica', 'italic');

            // Split long text into multiple lines if needed
            const maxWidth = (pageWidth - (3 * margin)) / 2 - 10;
            const splitText = doc.splitTextToSize(totalInWords, maxWidth);
            doc.text(splitText, margin + 5, currentY + 16);

            // Update current Y position after the totals section - Reduced spacing for small devis
            currentY += isSmallDevis ? 35 : 40;

            // Add terms and conditions - Condensed for small devis
            doc.setFontSize(9);
            doc.setTextColor(80, 80, 80);
            doc.setFont('helvetica', 'normal');
            doc.text("Conditions et modalités:", margin, currentY);
            doc.setFontSize(8);

            // Reduced line spacing for small devis
            const lineSpacing = isSmallDevis ? 5 : 7;
            doc.text(`• Ce devis est valable pour une durée de ${devis.validite || 30} jours à compter de sa date d'émission.`, margin, currentY + lineSpacing);
            doc.text("• Le paiement doit être effectué selon les conditions convenues.", margin, currentY + (lineSpacing * 2));
            doc.text("• Les prix indiqués sont en Dirhams (DH).", margin, currentY + (lineSpacing * 3));

            // Update current Y position after terms and conditions - Reduced spacing for small devis
            currentY += isSmallDevis ? 20 : 25;

            // Signature section - Optimized for small devis
            const signatureHeight = isSmallDevis ? 35 : 40;

            // Only add a new page if absolutely necessary - more accurate calculation
            const remainingSpace = pageHeight - footerHeight - currentY;
            if (remainingSpace < signatureHeight) {
                doc.addPage();
                addHeader(doc, false);
                addFooter(doc);
                currentY = 30; // Reset Y position on new page
            }

            // Add signature section - Condensed for small devis
            doc.setDrawColor(200, 200, 200);
            doc.setFontSize(9);
            doc.setTextColor(80, 80, 80);
            doc.setFont('helvetica', 'bold');
            doc.text("Signature et cachet:", margin, currentY);

            // Draw signature box - Smaller for small devis
            const signatureBoxHeight = isSmallDevis ? 20 : 25;
            doc.rect(margin, currentY + 5, 60, signatureBoxHeight, 'S');

            // Add client acceptance text - Condensed spacing for small devis
            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.setFont('helvetica', 'italic');
            const acceptanceSpacing = isSmallDevis ? 6 : 7;
            doc.text("Bon pour accord", rightColumnX, currentY + 8);
            doc.text("Date: ___________________", rightColumnX, currentY + 8 + acceptanceSpacing);
            doc.text("Nom: ___________________", rightColumnX, currentY + 8 + (acceptanceSpacing * 2));

            // Add footer to the first page
            addFooter(doc);

            // Add a note about the price type at the bottom of the document
            doc.setFontSize(7);
            doc.setTextColor(100, 100, 100);
            doc.setFont('helvetica', 'italic');
            doc.text(`* Document généré avec prix ${showTTCPrices ? 'TTC' : 'HT'}`, margin, pageHeight - footerHeight - 5);

            const pdfBlob = doc.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl);
        });
    };


    const handleDeleteDevis = (devisId) => {
        setPopoverOpen(!popoverOpen)
        Swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer ce devis?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer!',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(devisActions.delete({
                    id: devisId, onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Supprimé!',
                            text: 'Le Devis a été supprimée.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }
                }));
            }
        });
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedDevis) {
            setSelectedDevis(null);
        }
        let payload = {
            ...filters
        };
        dispatch(devisActions.list(payload));
    };


    const handleAcceptDevis = (devis) => {
        Swal.fire({
            title: 'Confirmation',
            text: "Le devis sera converti en bon de commande, voulez-vous confirmer?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(devisActions.accepterDevis({
                    id: devis.id,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Accepté!',
                            text: 'Le devis a été accepté avec succès.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        let payload = {
                            ...filters
                        };
                        dispatch(devisActions.list(payload));
                    }
                }));
            }
        });
    };

    const handleUpdateDevis = (devis) => {
        setSelectedDevis(devis);
        setShowModal(true);
        setPopoverOpen(!popoverOpen)
    };

    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(devisActions.list({
                ...filters,
                query: query
            }));
        }, 1500),
        [filters.query]
    );

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    // Create chantier options from selected client's chantiers
    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCashRegister className="text-primary me-2" />
                                {t('devis.list')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="mr-2" /> {t('devis.newDevis')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={3} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('reglement.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                        debouncedSearch(value);
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="chantierId">
                                                {t('chantier.title', 'Chantier')}:
                                            </Label>
                                            <Select
                                                id="chantierId"
                                                options={chantierOptionsWithAll}
                                                value={chantierOptionsWithAll.find(option => option.value === filters?.chantierId) || null}
                                                onChange={(selectedOption) => setFilters(f => ({ ...f, chantierId: selectedOption ? selectedOption.value : null }))}
                                                placeholder={t('chantier.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <table className="table table-hover table-striped table-bordered">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center">{t('devis.numero')}</th>
                                        <th className="align-middle text-center">{t('devis.client')}</th>
                                        <th className="align-middle text-center">{t('devis.chantier')}</th>
                                        <th className="align-middle text-center">{t('devis.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('devis.dateModification')}</th>
                                        <th className="align-middle text-center">{t('devis.dateOperation')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('devis.montantHT')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTVA')}</th>
                                        <th className="align-middle text-center">{t('devis.status')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((devis) => (
                                        <tr key={devis.id}>
                                            <td className="align-middle text-center">{devis.numero}</td>
                                            <td className="align-middle text-center">
                                                {devis.clientNom}
                                            </td>
                                            <td className="align-middle text-center">{devis.chantierNom || '-'}</td>
                                            <td className="align-middle text-center">{devis.dateCreation}</td>
                                            <td className="align-middle text-center">{devis.updatedAt || '-'}</td>
                                            <td className="align-middle text-center">{devis.dateOperation || '-'}</td>
                                            <td className="align-middle text-center">{formatPrice(devis.montantTotalTTC)}</td>
                                            <td className="align-middle text-center">{formatPrice(devis.montantTotalHT)}</td>
                                            <td className="align-middle text-center">{formatPrice(devis.montantTotalTaxe)}</td>
                                            <td className="align-middle text-center">
                                                {devis.statut === 'EN_ATTENTE' && (
                                                    <span className="badge bg-secondary">{t('devis.statusDraft')}</span>
                                                )}
                                                {devis.statut === 'VALIDE' && (
                                                    <span className="badge bg-success">{t('devis.statusValidated')}</span>
                                                )}
                                                {devis.statut === 'CANCELLED' && (
                                                    <span className="badge bg-danger">{t('devis.statusCancelled')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    <Button
                                                        color="secondary"
                                                        title={t('devis.downloadPdf')}
                                                        onClick={() => handleGeneratePdf(devis)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaFilePdf />
                                                    </Button>

                                                    {devis.statut === 'EN_ATTENTE' && <Button
                                                        color="success"
                                                        title={t('devis.devisValide')}
                                                        onClick={() => handleAcceptDevis(devis)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}

                                                    <Button
                                                        color="warning"
                                                        title={t('devis.edit')}
                                                        onClick={() => handleUpdateDevis(devis)}
                                                        size="sm"
                                                        className='me-1'
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        title={t('devis.cancel')}
                                                        onClick={() => handleDeleteDevis(devis.id)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaTrash />
                                                    </Button>

                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="11" className="text-center py-4">
                                                <div className="text-muted">{t('devis.noDevis')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}

                >{selectedDevis ? `${t('devis.editDevis')} N° ${selectedDevis.numero}` : t('devis.newDevis')}</ModalHeader>
                <ModalBody>
                    <DevisForm preloadedCompany={company} devis={selectedDevis} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default DevisList;